import { PagedResultDto } from '@umss/shared/data-access';
import {
  ExperienceLevelEnum,
  PositionTypeEnum,
  ScopeOfPracticeEnum
} from '@umss/shared/utils';

export interface JobPosting {
  /**
   * format: uuid
   */
  id?: string;

  facility?: JobPostingFacilityDto;

  /**
   * format: date-time
   */
  postedAt?: string;

  scopeOfPractice?: ScopeOfPracticeEnum;

  scopeOfPracticeDisplay?: string;

  positionType?: PositionTypeEnum;

  positionTypeDisplay?: string;

  experienceLevel?: ExperienceLevelEnum;

  experienceLevelDisplay?: string;

  lifecycleStage?: string;

  department?: string;

  priceRange?: JobPostingPriceRangeDto;

  /**
   * format: date-time
   */
  interestedAt?: string;
}

export interface JobPostingDetailDto extends JobPosting {
  description?: string;

  /**
   * format: date-time
   */
  closedAt?: string;

  closureOutcome?: number;

  closureOutcomeDisplay?: string;

  /**
   * format: int32
   */
  interestedCount?: number;
}

export interface JobPostingFacilityDto {
  /**
   * format: uuid
   */
  id?: string;

  name?: string;

  location?: string;

  fullAddress?: string;

  /**
   * format: double
   */
  distanceMiles?: number;
}

export interface JobPostingPriceRangeDto {
  /**
   * format: double
   */
  minHourlyRate?: number;

  /**
   * format: double
   */
  maxHourlyRate?: number;
}

export interface JobPostingSearchParams {
  search?: string;
  page?: number;
  pageSize?: number;
  maxDistanceMiles?: number;
  minHourlyRate?: number;
  maxHourlyRate?: number;
  scopesOfPractice?: string[];
  employmentTypes?: string[];
}

export type JobPostingPagedResult = PagedResultDto<JobPosting>;
